module.exports = __webpack_public_path__ + "img/Company-key-person.da388530.png";